import { plural, trans } from "@/_providers/Translation"
import { Button } from "@mui/material"
import removeImage from "@/assets/img/reservations/icons/remove.svg"
import Dropdown from "@/components/partials/Dropdown"

export default function ExceptionField({
  index,
  exception,
  onUpdateField,
  onRemove,
}) {
  return (
    <div className="device-container">
      <div className="head">
        {`${trans('labels.exception')} ${index + 1}`}
        {onRemove && (
          <Button
            onClick={(e) => {
              e.stopPropagation()
              onRemove(index)
            }}
          >
            <img src={removeImage} alt="Remove" />
          </Button>
        )}
      </div>
      <div className="body">
        <div className="row">
          <div className="col">
            <Dropdown
              inputIdValue={Number(exception.contractor_id)}
              url="contractors/active"
              renderText={(data) => {
                return data.name
              }}
              onChange={(data) => {
                // handleSupplier(data)
              }}
              inputPlaceholder={trans('labels.chooseCompany')}
              inputIdName={`exceptions[${index}][contractor_id]`}
              listStyle={{ height: "140px", overflowY: "auto" }}
            />
          </div>
          <div className="col" style={{ width: "fit-content", flexShrink: 0 }}>
            <select
              name={`exceptions[${index}][payment_terms_value]`}
              value={exception.payment_terms_value || 7}
              onChange={(e) =>
                onUpdateField(index, "payment_terms_value", e.target.value)
              }
            >
              <option value="7">{trans('random.upToOneWeek')}</option>
              <option value="14">{trans('random.upToTwoWeeks')}</option>
              <option value="21">{trans('random.upToThreeWeeks')}</option>
              <option value="28">{trans('random.upToFourWeeks')}</option>
            </select>
          </div>
          {exception.id ? (
            <input
              type="hidden"
              name={`exceptions[${index}][id]`}
              value={exception.id}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  )
}
